import SharedBloks from '@webcarelbj/shared-bloks'
import { overrideComponent } from '@webcarelbj/shared-components'
import RichtextResolver from '~/components/SepacRichtextResolver.vue'
import { WPElementButton, WPElementMedia } from '~/storyblok/tracking'

export default defineNuxtPlugin({
  name: 'shared-bloks',
  dependsOn: ['shared-components'],
  setup({ vueApp }) {
    vueApp.use(SharedBloks, {
      downloadBtn: { downloadDomainReplace: 'assets.pflege.de' },
    })

    // Override default components with the same name to inject our tracking.
    overrideComponent(WPElementButton)
    overrideComponent(WPElementMedia)
    overrideComponent(RichtextResolver, 'RichtextResolver')
  },
})
